<template>
  <div class="inv-add-inner-box">
    <div class="inv-add-content-box">
      <p class="inv-add-content-title">发票中奖查询</p>
      <ul class="inv-add-content-from">
        <li>
          <p>手机号：</p>
          <input
            type="number"
            placeholder="请输入手机号码"
            v-model="parmars.phone"
          />
        </li>
        <li>
          <p>发票期数：</p>
          <van-popup
            round
            v-model="show"
            position="bottom"
            :style="{ height: '310px' }"
          >
            <van-picker
              title="选择发票期数"
              show-toolbar
              :columns="actList"
              @confirm="onConfirm"
              @cancel="onCancel"
              @change="onChange"
            ></van-picker>
          </van-popup>

          <div class="select" @click="fn"></div>
        </li>
        <div class="inv-add-content-btn" @click="save">查询</div>
        <router-link to="/invoiceAdd" class="select-inv">发票录入</router-link>
      </ul>
    </div>
    <van-popup v-model="dialog.show" class="dialog-box">
      <div class="dialog-box-message">
        <div class="noaward" v-if="dialog.awardsNames.length ==0">
          <div>
            <img src="@/assets/img/noaward.png" alt="" />
          </div>
          <span>很遗憾大奖溜走了</span>
            <i class="close1" @click="changeShow"></i>
        </div>

        <div class="award" v-else>
          <h6>恭喜你 中奖了</h6>
          <ul v-if="dialog.awardsNames.length == 1">
            <li class="onlyone">
              <div>{{dialog.awardsNames[0].awardsName}}</div>
              <div>发票号码: {{ dialog.awardsNames[0].billNumber}}</div>
            </li>
          </ul>
          <ul v-else>
            <li v-for="(item, ind) in dialog.awardsNames" :key="ind">
              <div>{{ item.awardsName }}</div>
              <div>发票号码:{{ item.billNumber }}</div>
            </li>
          </ul>
          <i class="close" @click="changeShow"></i>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as sctipts from "../service/invoice";
export default {
  data() {
    return {
      show: false,
      isLock: false,
      parmars: {
        drawLotteryId: "",
        phone: "",
      },
      actList: [],
      dialog: {
        show: false,
        type: "success",
        message: "",
        awardsNames: [],
      },
    };
  },
  mounted() {
    this.getRem(750, 100);
    window.onresize = () => {
      this.getRem(750, 100);
    };
    document.title = "中奖查询";
    sctipts.getAct().then(({ data }) => {
      if (data.status == 0) {
        this.actList = data.data.list.map((item) => {
          item.text = item.drawLotteryName;
          return item;
        });
      }
    });
  },
  methods: {
    stopDefault(e){
      e.preventDefault();
    },
    onConfirm(value, index) {
      this.parmars.drawLotteryId = value.drawLotteryId;
      this.$nextTick(() => {
        document.querySelector(".select").innerHTML = value.drawLotteryName;
      });
      this.show = false;
    },
    onChange(picker, value, index) {
      this.parmars.drawLotteryId = value.drawLotteryId;
    },
    onCancel() {
      this.show = false;
    },
    fn() {
      this.show = true;
    },
    changeShow() {
      this.dialog.show = false;
      this.$nextTick(() => {
        document.querySelector(".select").innerHTML = "";
      });
    },
    getRem(pwidth, prem) {
      let html = document.getElementsByTagName("html")[0];
      let oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },
    checkPhone(value) {
      if (/^1[3456789]\d{9}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      if (this.parmars.phone == "") {
        alert("请输入手机号码");
      } else if (!this.checkPhone(this.parmars.phone)) {
        alert("请输入正确的手机号码");
      } else if (this.parmars.drawLotteryId == "") {
        alert("请选择发票期数");
      } else {
        let data = JSON.parse(JSON.stringify(this.parmars));
        sctipts
          .getbill(data)
          .then(({ data }) => {
            if (data.status == 0) {
              if (data.data.length == 0) {
                this.dialog.show = true;
                this.dialog.awardsNames = data.data;
              } else {
                this.dialog.show = true;
                this.dialog.awardsNames = data.data;
              }
              this.parmars = {
                drawLotteryId: "",
                phone: "",
              };
            } else {
              alert(data.desc);
            }
          })
          .catch(() => {
            alert("系统异常");
          });
      }
    },
  },
};
</script>

<style scoped>
.select {
  width: calc(100% - 1.8rem);
  display: block;
  height: 0.72rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
  border: 1px solid #b2b2b2;
  border-radius: 0.1rem;
  outline: none;
  appearance: none;
  font-size: 0.28rem;
  line-height: 0.72rem;
  color: #666;
  background-color: #fff;
  flex-shrink: 0;
}
.inv-add-inner-box {
  width: 100%;
  height: 100%;
  background: url("../assets/img/hbeij.png") no-repeat center top / cover;
  overflow: hidden;
}
.inv-add-content-box {
  width: calc(100% - 0.6rem);
  /* height: calc(100% - 3.5rem); */
  height: 6rem;
  border-radius: 0.1rem;
  margin: 2.83rem auto 0;
  background-color: #fff;
  overflow: hidden;
}
.inv-add-content-title {
  width: 4rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.32rem;
  color: #fff;
  background: url("../assets/img/biaotiit.png") no-repeat center center / cover;
  margin: 0.3rem auto;
}
.inv-add-content-from {
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 1.5rem);
  padding: 0 0.6rem;
  margin: 0 auto;
  overflow: auto;
}
.inv-add-content-from > li {
  height: 0.74rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.28rem;
}
.inv-add-content-from > li > p {
  width: 1.8rem;
  font-size: 0.32rem;
  color: #343434;
  flex-shrink: 0;
}
.noaward span {
  color: #666;
  font-weight: 600;
  font-size: 0.3rem;
  text-align: center;
  position: absolute;
  top: 2.2rem;
  left: 1.55rem;
}
.inv-add-content-from > li > input,
.inv-add-content-from > li > select {
  width: calc(100% - 1.8rem);
  display: block;
  height: 0.72rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
  border: 1px solid #b2b2b2;
  border-radius: 0.1rem;
  outline: none;
  appearance: none;
  font-size: 0.28rem;
  line-height: 0.72rem;
  color: #666;
  background-color: #fff;
  flex-shrink: 0;
}
.inv-add-content-btn {
  width: 4.3rem;
  height: 0.8rem;
  background-color: #549af6;
  color: #ffffff;
  font-size: 0.32rem;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  margin: 0.76rem auto 0.3rem;
}
.select-inv {
  color: #999;
  font-size: 0.24rem;
  display: block;
  text-align: center;
  margin-bottom: 0.3rem;
  text-decoration: none;
}
.code-box {
  width: calc(100% - 1.8rem);
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.code-box > input {
  display: block;
  height: 0.72rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
  border: 1px solid #b2b2b2;
  border-radius: 0.1rem;
  outline: none;
  appearance: none;
  font-size: 0.28rem;
  line-height: 0.72rem;
  color: #666;
  background-color: #fff;
  flex-shrink: 0;
}
.dialog-box {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.0);
  position: fixed;
  /* left: 0;
  top: 0; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-box-message {
  width: 6rem;
  /* background-color: #eee; */
  border-radius: 0.1rem;
  position: relative;
  height: 7.6rem;
  letter-spacing: 0.04rem;
}

.dialog-box-message .noaward {
  text-align: center;
  /* height: 5rem; */
  position: relative;
}
.dialog-box-message .close {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  bottom: -1.2rem;
  right: calc(50% - 0.4rem);
  background-image: url("../assets/img/close.png");
  background-position: center;
  background-repeat: no-repeat;
}

.dialog-box-message .noaward > img {
  display: block;
  transform: scale(1.5);
  width: 3.5rem;
  height: 2.5rem;
  margin: 0 auto;
}
.dialog-box-message .award {
  height: 100%;
  background-image: url("../assets/img/awards.png");
  background-repeat: no-repeat;
  background-position: 0.1rem center;
  background-size: 100% 100%;
  /* height: 6rem; */
  padding: 0 0.4rem;
  padding-bottom: 0.2rem;
  text-align: center;
}
.award h6 {
  color: #fff;
  font-weight: 600;
  font-size: 0.44rem;
  text-align: center;
  padding-top: 0.2rem;
}
.award ul {
  margin-top: 0.68rem;
  background-color: #fff;
  border-radius: 0.1rem;
  padding: 0.2rem;
  font-size: 0.32rem;
  color: #333;
  height: 5.5rem;
  overflow-y: auto;
  padding-top: 0;
}
.award ul li {
  margin: 0.679rem 0;
}
.award .onlyone {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.award li div:nth-child(1) {
  margin-bottom: 0.1rem;
  font-size: 0.34rem;
  color: #3576e3;
  font-weight: bolder;
}
.close1 {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  bottom: -0.8rem;
  right: calc(50% - 0.4rem);
  color: #ccc;
  background-image: url("../assets/img/close.png");
  background-position: center;
  background-repeat: no-repeat;
}
</style>